import { render } from "./CustomerCompanyCreditAndAccountingPeriodDetail.vue?vue&type=template&id=a484f00a&ts=true"
import script from "./CustomerCompanyCreditAndAccountingPeriodDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerCompanyCreditAndAccountingPeriodDetail.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__